import { render, staticRenderFns } from "./norilskSelect.vue?vue&type=template&id=79ad331e&scoped=true&"
import script from "./norilskSelect.vue?vue&type=script&lang=js&"
export * from "./norilskSelect.vue?vue&type=script&lang=js&"
import style0 from "./norilskSelect.vue?vue&type=style&index=0&id=79ad331e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ad331e",
  null
  
)

export default component.exports